import { ElementRef, OnDestroy, OnInit, Renderer2, Directive } from '@angular/core';
import { merge, Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SecurityClaim } from '../../../auth/models/security-claim.model';
import { AuthService } from '../../../auth/services/auth.service';

@Directive()
export abstract class BaseHasTransactionDirective implements OnInit, OnDestroy {
    protected _hasView = false;
    protected _previousTransaction: any;
    protected transactionsUpdated$: Observable<SecurityClaim[]>;
    private idTokenUpdated$: Observable<string>;
    private subscription: Subscription;

    abstract condition(securityTransaction: any): boolean;

    constructor(
        protected _authService: AuthService,
        protected _elementRef: ElementRef,
        protected _renderer: Renderer2) {
        // if the id token gets updated, we need to re-evaluate
        this.idTokenUpdated$ = this._authService.idTokenUpdated;
    }

    ngOnInit() {
        this.subscription = merge(this.idTokenUpdated$, this.transactionsUpdated$)
            .pipe(filter(() => this._previousTransaction !== undefined))
            .subscribe(() => this.updateView(this._previousTransaction));
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this._elementRef = null;
    }

    protected updateView(transaction: any) {
        this._previousTransaction = transaction;
        const conditionResult = this.condition(transaction);

        if (this._elementRef.nativeElement.classList != undefined) {
            if (conditionResult) {
                this._renderer.removeClass(this._elementRef.nativeElement, 'hidden');
            } else {
                this._renderer.addClass(this._elementRef.nativeElement, 'hidden');
            }
        }
    }
}
